export default __webpack_public_path__ + "change-log.978bbcad65549ae8.svg";